class e{static set(c){e._graphicsDevice=c}static get(){return e._graphicsDevice}}e._graphicsDevice=null;export{e as GraphicsDeviceAccess};
